import { LandingPageTemplate10 } from "./LandingPageTemplate10";
import { LandingPageTemplate11 } from "./LandingPageTemplate11";
import { LandingPageTemplate12 } from "./LandingPageTemplate12";
import { LandingPageTemplate13 } from "./LandingPageTemplate13";
import { LandingPageTemplate14 } from "./LandingPageTemplate14";
import { LandingPageTemplate15 } from "./LandingPageTemplate15";
import { LandingPageTemplate16 } from "./LandingPageTemplate16";
import { LandingPageTemplate17 } from "./LandingPageTemplate17";
import { LandingPageTemplate18 } from "./LandingPageTemplate18";
import { LandingPageTemplate19 } from "./LandingPageTemplate19";
import { LandingPageTemplate20 } from "./LandingPageTemplate20";
import { LandingPageTemplate21 } from "./LandingPageTemplate21";
import { LandingPageTemplate22 } from "./LandingPageTemplate22";
import { LandingPageTemplate23 } from "./LandingPageTemplate23";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplateOptions: Record<
  number,
  LandingPageConfigOptions
> = {
  10: LandingPageTemplate10,
  11: LandingPageTemplate11,
  12: LandingPageTemplate12,
  13: LandingPageTemplate13,
  14: LandingPageTemplate14,
  15: LandingPageTemplate15,
  16: LandingPageTemplate16,
  17: LandingPageTemplate17,
  18: LandingPageTemplate18,
  19: LandingPageTemplate19,
  20: LandingPageTemplate20,
  21: LandingPageTemplate21,
  22: LandingPageTemplate22,
  23: LandingPageTemplate23,
};
